module AI

open FSharpPlus
open Client
open Fable.React
open Fable.React.Props
open Model
open Fulma
open PortalLibs.Client.Util
open ContractPageModel

let randomAiInfo (contract: Contract) =
  let rnd = System.Random()
  let succ = (rnd.Next(30, 100) |> float) / 100.0

  { ContractId = contract.Id
    SuccessRate = succ }

let chartView (histories: JobHistory seq) (aiHistories: JobHistory seq) =
  let costData =
    histories
    |>> (fun h -> h.Date |> prettyPrintDateDashes, h.Cost)
    |> Seq.toArray

  let billingData =
    histories
    |>> fun h -> h.Date |> prettyPrintDateDashes, h.Billing
    |> Seq.toArray

  let aiCostData =
    aiHistories
    |>> fun (h: JobHistory) -> h.Date |> prettyPrintDateDashes, h.Cost
    |> Seq.toArray

  let aiBillingData =
    aiHistories
    |>> fun h -> h.Date |> prettyPrintDateDashes, h.Billing
    |> Seq.toArray

  let inputProps =
    {| prefix = "$"
       thousands = ","
       height = "400px"
       data =
         [| {| name = "Costs"; data = costData |}
            {| name = "Billing"; data = billingData |}
            {| name = "AI Costs"; data = aiCostData |}
            {| name = "AI Billing"; data = aiBillingData |} |]
       library =
         {| responsive = true
            hover = {| mode = "nearest"; intersect = true |}
            scales =
              {| y =
                  {| display = true
                     ticks = {| display = true; maxTicksLimit = 6 |}
                     gridLines = {| display = true |} |}
                 x = {| display = true
                        gridLines =
                          {| display = true
                             color = "rgba(0, 0, 0, 0.1)"
                             lineWidth = 1
                             drawOnChartArea = 1 |} |} |}
            animation = {| duration = 1500; easing = "easeOutElastic" |}                             
            legend = {| position = "bottom" |}
            tooltip =
                  {| mode = "index"
                     intersect = false
                     displayColors = true
                     xPadding = 10
                     yPadding = 10
                     bodySpacing = 4 |}
            |} |}
  
  ofImport "LineChart" "react-chartkick" inputProps []

let view model (contract: Contract) aiInfos =
  let jobHistoriesOpt =
    Map.tryFind contract.Id model.JobHistories

  let aiHistoriesOpt =
    Map.tryFind contract.Id model.AIJobHistories

  let aiInfoOpt = Map.tryFind contract.Id aiInfos

  match aiInfoOpt, jobHistoriesOpt, aiHistoriesOpt with
  | Some aiInfo, Some jobHistories, Some aiHistories ->
    div [ Style [ PaddingBottom "50px" ] ] [
      div [ Style [
              MaxWidth "900px"
              MarginBottom "40px"
              MarginLeft "20px"
              ] ] [
        Heading.h5 [] [
          str "Estimated Project Outcome"
        ]
        div [ Style [
                Display DisplayOptions.Flex
                FlexWrap "wrap"
                MaxWidth "870px"
                AlignSelf AlignSelfOptions.FlexEnd
              ] ] [
          match jobHistories |> List.tryLast with
          | Some last ->
            yield
              textFieldReadOnly
                "Completion Date"
                (match contract.EstCompletion with
                 | None -> ""
                 | Some date -> date |> prettyPrintDateLong)

            yield
              textFieldReadOnly
                "Final Costs"
                (last.Cost
                 |> DisplayNumber.AsCurrency.std)

            yield
              textFieldReadOnly
                "Final Billing"
                (last.Billing
                 |> DisplayNumber.AsCurrency.std)

            yield
              textFieldReadOnly
                "Final Profit"
                (last.Billing - last.Cost
                 |> DisplayNumber.AsCurrency.std)

            yield
              textFieldReadOnly
                "Final GP%"
                (sprintf
                  "%s%%"
                  (System
                    .Math
                    .Round(
                      (((last.Billing - last.Cost) / last.Billing)
                       * 100.0),
                      1
                    )
                    .ToString()))
          | None -> ()
        ]
        Heading.h5 [] [
          str "AI Predicted Project Outcome"
        ]
        textFieldReadOnly
          "Success Rate"
          (sprintf
            "%s%%"
            (System
              .Math
              .Round(aiInfo.SuccessRate * 100.0, 1)
              .ToString()))
        div [ Style [
                Display DisplayOptions.Flex
                FlexWrap "wrap"
                MaxWidth "870px"
                AlignSelf AlignSelfOptions.FlexEnd
              ] ] [
          match aiHistories |> List.tryLast with
          | Some last ->
            yield textFieldReadOnly "Completion Date" (last.Date |> prettyPrintDateLong)

            yield
              textFieldReadOnly
                "Final Costs"
                (last.Cost
                 |> DisplayNumber.AsCurrency.std)

            yield
              textFieldReadOnly
                "Final Billing"
                (last.Billing
                 |> DisplayNumber.AsCurrency.std)

            yield
              textFieldReadOnly
                "Final Profit"
                (last.Billing - last.Cost
                 |> DisplayNumber.AsCurrency.std)

            yield
              textFieldReadOnly
                "Final GP%"
                (sprintf
                  "%s%%"
                  (System
                    .Math
                    .Round(
                      (((last.Billing - last.Cost) / last.Billing)
                       * 100.0),
                      1
                    )
                    .ToString()))
          | None -> ()
        ]
      ]
      chartView jobHistories aiHistories
    ]
  | _, _, _ -> nothing
